import { render, staticRenderFns } from "./STableProviderComp.vue?vue&type=template&id=6cc2552a&"
import script from "./STableProviderComp.vue?vue&type=script&lang=js&"
export * from "./STableProviderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports